module.exports = __webpack_public_path__ + "img/78.d205ca7c.webp";